const PB_ADMIN_2_ACCESS = 'PB_ADMIN_2_ACCESS';
const WEBSITE_ADMIN_ACCESS = 'WEBSITE_ADMIN_ACCESS';
const GDPR_TOOL_USER = 'GDPR_TOOL_USER';
const MOBILE_ADMIN = 'MOBILE_ADMIN';
const LOGIN_AS = 'LOGIN_AS';

const ACCOUNT_SCREEN_VIEW = 'ACCOUNT_SCREEN_VIEW';
const ACCOUNT_SCREEN_EDIT = 'ACCOUNT_SCREEN_EDIT';
const ACCOUNT_SCREEN_CREATE = 'ACCOUNT_SCREEN_CREATE';
const ACCOUNT_SCREEN_DELETE = 'ACCOUNT_SCREEN_DELETE';
const ACCOUNT_LIMITS_VIEW = 'ACCOUNT_LIMITS_VIEW';
const ACCOUNT_LIMITS_EDIT = 'ACCOUNT_LIMITS_EDIT';
const ACCOUNT_PRODUCTS_VIEW = 'ACCOUNT_PRODUCTS_VIEW';
const ACCOUNT_PRODUCTS_EDIT = 'ACCOUNT_PRODUCTS_EDIT';
const ACCOUNT_PRODUCTS_CREATE = 'ACCOUNT_PRODUCTS_CREATE';
const ACCOUNT_PRODUCTS_DELETE = 'ACCOUNT_PRODUCTS_DELETE';
const ALL_LICENSE_TYPES_ACCESS = 'ALL_LICENSE_TYPES_ACCESS';
const GLOBAL_ACCOUNT_MANAGEMENT = 'GLOBAL_ACCOUNT_MANAGEMENT';

const USER_SCREEN_VIEW = 'USER_SCREEN_VIEW';
const USER_SCREEN_EDIT = 'USER_SCREEN_EDIT';
const USER_SCREEN_CREATE = 'USER_SCREEN_CREATE';
const USER_SCREEN_DELETE = 'USER_SCREEN_DELETE';
const USER_LIMITS_VIEW = 'USER_LIMITS_VIEW';
const USER_LIMITS_EDIT = 'USER_LIMITS_EDIT';
const USER_PRODUCTS_VIEW = 'USER_PRODUCTS_VIEW';
const USER_PRODUCTS_EDIT = 'USER_PRODUCTS_EDIT';
const USER_PRODUCTS_CREATE = 'USER_PRODUCTS_CREATE';
const USER_PRODUCTS_DELETE = 'USER_PRODUCTS_DELETE';
const USER_MFA_MANAGEMENT = 'USER_MFA_MANAGEMENT';
const CHANGE_USER_ACCOUNT = 'CHANGE_USER_ACCOUNT';
const USER_CONTENT_VIEW = 'USER_CONTENT_VIEW';

const LICENSE_SCREEN_VIEW = 'LICENSE_SCREEN_VIEW';
const LICENSE_SCREEN_EDIT = 'LICENSE_SCREEN_EDIT';
const LICENSE_SCREEN_CREATE = 'LICENSE_SCREEN_CREATE';

const GROUP_SCREEN_VIEW = 'GROUP_SCREEN_VIEW';
const GROUP_SCREEN_EDIT = 'GROUP_SCREEN_EDIT';
const GROUP_SCREEN_CREATE = 'GROUP_SCREEN_CREATE';
const GROUP_SCREEN_DELETE = 'GROUP_SCREEN_DELETE';
const API_V2_SCREEN_VIEW = 'API_V2_SCREEN_VIEW';
const API_V2_SCREEN_EDIT = 'API_V2_SCREEN_EDIT';
const SSO_SCREEN_VIEW = 'SSO_SCREEN_VIEW';
const SSO_SCREEN_EDIT = 'SSO_SCREEN_EDIT';
const CRM_SCREEN_VIEW = 'CRM_SCREEN_VIEW';
const CRM_SCREEN_EDIT = 'CRM_SCREEN_EDIT';
const MICROSITES_SCREEN_VIEW = 'MICROSITES_SCREEN_VIEW';
const MICROSITES_SCREEN_EDIT = 'MICROSITES_SCREEN_EDIT';
const ACCOUNT_DD_MCP_VIEW = 'ACCOUNT_DD_MCP_VIEW';
const ACCOUNT_DD_MCP_EDIT = 'ACCOUNT_DD_MCP_EDIT';
const ACCOUNT_CONNECTOR_LIMITS_VIEW = 'ACCOUNT_CONNECTOR_LIMITS_VIEW';
const ACCOUNT_CONNECTOR_LIMITS_EDIT = 'ACCOUNT_CONNECTOR_LIMITS_EDIT';
const USER_CONNECTOR_LIMITS_VIEW = 'USER_CONNECTOR_LIMITS_VIEW';
const USER_CONNECTOR_LIMITS_EDIT = 'USER_CONNECTOR_LIMITS_EDIT';
const BULK_UPDATE_USER_CRM = 'BULK_UPDATE_USER_CRM';
const BULK_REMOVE_ACCOUNT_TEAM_MEMBERS = 'BULK_REMOVE_ACCOUNT_TEAM_MEMBERS';
const BULK_USER_IMPORT = 'BULK_USER_IMPORT';
const BULK_ACCOUNT_TEAM_MEMBER = 'BULK_ACCOUNT_TEAM_MEMBER';
const BULK_ACCOUNT_STATUS_UPDATE = 'BULK_ACCOUNT_STATUS_UPDATE';
const BULK_USER_STATUS_UPDATE = 'BULK_USER_STATUS_UPDATE';
const BULK_USER_STATE_UPDATE = 'BULK_USER_STATE_UPDATE';
const BULK_ACCOUNT_GROUP_UPDATE = 'BULK_ACCOUNT_GROUP_UPDATE';
const BULK_NEWSLETTER_SUBSCRIPTION_UPDATE = 'BULK_NEWSLETTER_SUBSCRIPTION_UPDATE';
const BULK_USER_ACCOUNT_CHANGE = 'BULK_USER_ACCOUNT_CHANGE';
const BULK_UPDATE_DEVICE_REGISTRATION = 'BULK_UPDATE_DEVICE_REGISTRATION';
const BULK_MFA_SETTINGS_UPDATE = 'BULK_MFA_SETTINGS_UPDATE';
const BULK_LICENSE_UPDATE = 'BULK_LICENSE_UPDATE';
const BULK_PRODUCTS_UPDATE = 'BULK_PRODUCTS_UPDATE';
const LCD_CREDIT_ANALYSIS_BULK_UPDATE = 'LCD_CREDIT_ANALYSIS_BULK_UPDATE';
const MANAGE_PERMISSIONS_FOR_A_PROFILE = 'MANAGE_PERMISSIONS_FOR_A_PROFILE';
const PII_VIEWABLE = 'PII_VIEWABLE';
const PII_EDITABLE = 'PII_EDITABLE';
const ANALYST_COMMENTARY_DEALS = 'ANALYST_COMMENTARY_DEALS';
const CREATE_MARKET_MAP_VERTICALS = 'CREATE_MARKET_MAP_VERTICALS';
const PUBLISH_WORKSPACES = 'PUBLISH_WORKSPACES';
const MANAGE_SYSTEM_ACCOUNTS = 'MANAGE_SYSTEM_ACCOUNTS';
const MANAGE_SYSTEM_PROPERTIES = 'MANAGE_SYSTEM_PROPERTIES';
const TEMPORARY_RESTRICTION_CHINA = 'TEMPORARY_RESTRICTION_CHINA';
const ACCOUNT_REPORTS_SCREEN_VIEW = 'ACCOUNT_REPORTS_SCREEN_VIEW';

const BULK_LOGIN_LINK_GENERATOR = 'BULK_LOGIN_LINK_GENERATOR';
const MANAGE_ENTITLEMENTS = 'MANAGE_ENTITLEMENTS';
const DELETE_ENTITLEMENTS = 'DELETE_ENTITLEMENTS';
const MANAGE_ENTITLEMENT_PRESET = 'MANAGE_ENTITLEMENT_PRESET';
const DELETE_ENTITLEMENT_PRESET = 'DELETE_ENTITLEMENT_PRESET';
const LIVE_AGENT_CONFIGURATOR = 'LIVE_AGENT_CONFIGURATOR';
const PLATFORM_ALERT_BUILDER = 'PLATFORM_ALERT_BUILDER';
const INTERNAL_NOTIFICATION_BUILDER = 'INTERNAL_NOTIFICATION_BUILDER';
const FULL_STORY_CONFIGURATOR = 'FULL_STORY_CONFIGURATOR';
const SSO_ACCOUNT_STATISTICS = 'SSO_ACCOUNT_STATISTICS';

const EXPORT_ENTITLEMENTS = 'EXPORT_ENTITLEMENTS';
const IMPORT_ENTITLEMENTS = 'IMPORT_ENTITLEMENTS';

const USER_ENTITLEMENTS_VIEW = 'USER_ENTITLEMENTS_VIEW';
const USER_ENTITLEMENTS_EDIT = 'USER_ENTITLEMENTS_EDIT';
const ACCOUNT_ENTITLEMENTS_VIEW = 'ACCOUNT_ENTITLEMENTS_VIEW';
const ACCOUNT_ENTITLEMENTS_EDIT = 'ACCOUNT_ENTITLEMENTS_EDIT';

const CONFERENCE_SETUP = 'CONFERENCE_SETUP';
const CONFERENCE_EDIT = 'CONFERENCE_EDIT';
const CONFERENCE_VIEW = 'CONFERENCE_VIEW';

export const ACCESS_RIGHTS = {
    PB_ADMIN_2_ACCESS,
    WEBSITE_ADMIN_ACCESS,
    GDPR_TOOL_USER,
    MOBILE_ADMIN,
    LOGIN_AS,

    PII_VIEWABLE,
    PII_EDITABLE,

    ACCOUNT_SCREEN_VIEW,
    ACCOUNT_SCREEN_EDIT,
    ACCOUNT_SCREEN_CREATE,
    ACCOUNT_SCREEN_DELETE,
    ACCOUNT_LIMITS_VIEW,
    ACCOUNT_LIMITS_EDIT,
    ACCOUNT_PRODUCTS_VIEW,
    ACCOUNT_PRODUCTS_EDIT,
    ACCOUNT_PRODUCTS_CREATE,
    ACCOUNT_PRODUCTS_DELETE,
    ACCOUNT_ENTITLEMENTS_VIEW,
    ACCOUNT_ENTITLEMENTS_EDIT,
    ACCOUNT_REPORTS_SCREEN_VIEW,
    GLOBAL_ACCOUNT_MANAGEMENT,

    USER_SCREEN_VIEW,
    USER_SCREEN_EDIT,
    USER_SCREEN_CREATE,
    USER_SCREEN_DELETE,
    USER_LIMITS_VIEW,
    USER_LIMITS_EDIT,
    USER_PRODUCTS_VIEW,
    USER_PRODUCTS_EDIT,
    USER_PRODUCTS_CREATE,
    USER_PRODUCTS_DELETE,
    USER_ENTITLEMENTS_VIEW,
    USER_ENTITLEMENTS_EDIT,
    USER_MFA_MANAGEMENT,
    CHANGE_USER_ACCOUNT,
    USER_CONTENT_VIEW,

    LICENSE_SCREEN_VIEW,
    LICENSE_SCREEN_EDIT,
    LICENSE_SCREEN_CREATE,
    ALL_LICENSE_TYPES_ACCESS,

    GROUP_SCREEN_VIEW,
    GROUP_SCREEN_EDIT,
    GROUP_SCREEN_CREATE,
    GROUP_SCREEN_DELETE,

    API_V2_SCREEN_VIEW,
    API_V2_SCREEN_EDIT,

    SSO_SCREEN_VIEW,
    SSO_SCREEN_EDIT,

    CRM_SCREEN_VIEW,
    CRM_SCREEN_EDIT,

    MICROSITES_SCREEN_VIEW,
    MICROSITES_SCREEN_EDIT,

    ACCOUNT_DD_MCP_VIEW,
    ACCOUNT_DD_MCP_EDIT,
    ACCOUNT_CONNECTOR_LIMITS_VIEW,
    ACCOUNT_CONNECTOR_LIMITS_EDIT,
    USER_CONNECTOR_LIMITS_VIEW,
    USER_CONNECTOR_LIMITS_EDIT,

    BULK_UPDATE_USER_CRM,
    BULK_REMOVE_ACCOUNT_TEAM_MEMBERS,
    BULK_USER_IMPORT,
    BULK_ACCOUNT_TEAM_MEMBER,
    BULK_ACCOUNT_STATUS_UPDATE,
    BULK_USER_STATE_UPDATE,
    BULK_USER_STATUS_UPDATE,
    BULK_ACCOUNT_GROUP_UPDATE,
    BULK_NEWSLETTER_SUBSCRIPTION_UPDATE,
    BULK_USER_ACCOUNT_CHANGE,
    BULK_LICENSE_UPDATE,
    BULK_PRODUCTS_UPDATE,
    BULK_UPDATE_DEVICE_REGISTRATION,
    BULK_MFA_SETTINGS_UPDATE,
    LCD_CREDIT_ANALYSIS_BULK_UPDATE,
    EXPORT_ENTITLEMENTS,
    IMPORT_ENTITLEMENTS,

    BULK_LOGIN_LINK_GENERATOR,
    MANAGE_PERMISSIONS_FOR_A_PROFILE,
    PLATFORM_ALERT_BUILDER,
    INTERNAL_NOTIFICATION_BUILDER,
    LIVE_AGENT_CONFIGURATOR,
    FULL_STORY_CONFIGURATOR,

    ANALYST_COMMENTARY_DEALS,
    CREATE_MARKET_MAP_VERTICALS,

    PUBLISH_WORKSPACES,
    MANAGE_SYSTEM_ACCOUNTS,
    MANAGE_SYSTEM_PROPERTIES,
    TEMPORARY_RESTRICTION_CHINA,

    MANAGE_ENTITLEMENTS,
    DELETE_ENTITLEMENTS,
    MANAGE_ENTITLEMENT_PRESET,
    DELETE_ENTITLEMENT_PRESET,

    CONFERENCE_SETUP,
    CONFERENCE_EDIT,
    CONFERENCE_VIEW,
    SSO_ACCOUNT_STATISTICS,
};

export const ACCESS_RIGHTS_LABELS = {
    [ACCOUNT_PRODUCTS_VIEW]: 'View Account Products',
    [ACCOUNT_PRODUCTS_EDIT]: 'Edit Account Products',
    [ACCOUNT_PRODUCTS_CREATE]: 'Create Account Products',
    [ACCOUNT_PRODUCTS_DELETE]: 'Delete Account Products',

    [USER_PRODUCTS_VIEW]: 'View User Products',
    [USER_PRODUCTS_EDIT]: 'Edit User Products',
    [USER_PRODUCTS_CREATE]: 'Create User Products',
    [USER_PRODUCTS_DELETE]: 'Delete User Products',

    [BULK_PRODUCTS_UPDATE]: 'Bulk Update Products',

    [PII_VIEWABLE]: 'Customer PII Viewable',
    [PII_EDITABLE]: 'Customer PII Editable',

    [PB_ADMIN_2_ACCESS]: 'PB Admin 2.0 Access',
    [GDPR_TOOL_USER]: 'GDPR Tool Access',
    [WEBSITE_ADMIN_ACCESS]: 'PB Website Admin Access',
    [MOBILE_ADMIN]: 'PB Mobile Admin Access',
    [LOGIN_AS]: 'Login As',
    [USER_MFA_MANAGEMENT]: 'User MFA Management',

    [ACCOUNT_SCREEN_VIEW]: 'View Account Information',
    [ACCOUNT_SCREEN_EDIT]: 'Edit Account Information',
    [ACCOUNT_SCREEN_CREATE]: 'Create Account Information',
    [ACCOUNT_SCREEN_DELETE]: 'Delete Account Information',

    [ACCOUNT_LIMITS_VIEW]: 'View Account Limits',
    [ACCOUNT_LIMITS_EDIT]: 'Edit Account Limits',

    [ALL_LICENSE_TYPES_ACCESS]: 'All License Types Access',
    [GLOBAL_ACCOUNT_MANAGEMENT]: 'Global Account Management',

    [USER_SCREEN_VIEW]: 'View Users',
    [USER_SCREEN_EDIT]: 'Edit Users',
    [USER_SCREEN_CREATE]: 'Create Users',
    [USER_SCREEN_DELETE]: 'Delete Users',
    [CHANGE_USER_ACCOUNT]: 'Change User\'s Account',
    [USER_CONTENT_VIEW]: 'View User Content',

    [USER_LIMITS_VIEW]: 'View User Limits',
    [USER_LIMITS_EDIT]: 'Edit User Limits',

    [USER_ENTITLEMENTS_VIEW]: 'View User Entitlements',
    [USER_ENTITLEMENTS_EDIT]: 'Edit User Entitlements',

    [LICENSE_SCREEN_VIEW]: 'View Account Licenses',
    [LICENSE_SCREEN_EDIT]: 'Edit Account Licenses',
    [LICENSE_SCREEN_CREATE]: 'Create Account Licenses',

    [GROUP_SCREEN_VIEW]: 'View Account Groups',
    [GROUP_SCREEN_EDIT]: 'Edit Account Groups',
    [GROUP_SCREEN_CREATE]: 'Create Account Groups',
    [GROUP_SCREEN_DELETE]: 'Delete Account Groups',

    [API_V2_SCREEN_VIEW]: 'View API v2',
    [API_V2_SCREEN_EDIT]: 'Edit API v2',

    [SSO_SCREEN_VIEW]: 'View SSO',
    [SSO_SCREEN_EDIT]: 'Edit SSO',

    [CRM_SCREEN_VIEW]: 'View CRM',
    [CRM_SCREEN_EDIT]: 'Edit CRM',

    [MICROSITES_SCREEN_VIEW]: 'View Microsite Configurations',
    [MICROSITES_SCREEN_EDIT]: 'Edit Microsite Configurations',

    [ACCOUNT_DD_MCP_VIEW]: 'View DD MCP Configuration',
    [ACCOUNT_DD_MCP_EDIT]: 'Edit DD MCP Configuration',
    [ACCOUNT_CONNECTOR_LIMITS_VIEW]: 'View Account Connector Limits',
    [ACCOUNT_CONNECTOR_LIMITS_EDIT]: 'Edit Account Connector Limits',
    [USER_CONNECTOR_LIMITS_VIEW]: 'View User Connector Limits',
    [USER_CONNECTOR_LIMITS_EDIT]: 'Edit User Connector Limits',

    [ACCOUNT_ENTITLEMENTS_VIEW]: 'View Account Entitlements',
    [ACCOUNT_ENTITLEMENTS_EDIT]: 'Edit Account Entitlements',

    [ACCOUNT_REPORTS_SCREEN_VIEW]: 'View Account Reports',

    [BULK_USER_IMPORT]: 'Bulk Add Users',
    [BULK_UPDATE_USER_CRM]: 'Bulk Update User CRM IDs',
    [BULK_REMOVE_ACCOUNT_TEAM_MEMBERS]: 'Bulk Remove from Account Team',
    [BULK_ACCOUNT_TEAM_MEMBER]: 'Bulk Add to Account Team',
    [BULK_ACCOUNT_STATUS_UPDATE]: 'Bulk Set Account Status',
    [BULK_USER_STATE_UPDATE]: 'Bulk Set User State',
    [BULK_USER_STATUS_UPDATE]: 'Bulk Set User Status',
    [BULK_ACCOUNT_GROUP_UPDATE]: 'Bulk Set Account Group',
    [BULK_NEWSLETTER_SUBSCRIPTION_UPDATE]: 'Bulk Set Newsletter Subscription',
    [BULK_USER_ACCOUNT_CHANGE]: 'Bulk Change User\'s Account',
    [BULK_LICENSE_UPDATE]: 'Bulk Update License',
    [BULK_UPDATE_DEVICE_REGISTRATION]: 'Bulk Update Device Registration',
    [BULK_MFA_SETTINGS_UPDATE]: 'Bulk Update MFA Settings',
    [BULK_LOGIN_LINK_GENERATOR]: 'Login Link Generator',
    [LCD_CREDIT_ANALYSIS_BULK_UPDATE]: 'Bulk Update LCD Credit Analysis Subscription',
    [EXPORT_ENTITLEMENTS]: 'Export Entitlements',
    [IMPORT_ENTITLEMENTS]: 'Import Entitlements',

    [MANAGE_PERMISSIONS_FOR_A_PROFILE]: 'Manage Roles & Permissions',
    [LIVE_AGENT_CONFIGURATOR]: 'Live Agent Configurator',
    [PLATFORM_ALERT_BUILDER]: 'Platform Alert Builder',
    [INTERNAL_NOTIFICATION_BUILDER]: 'Internal Notification Builder',
    [FULL_STORY_CONFIGURATOR]: 'FullStory Configurator',
    [MANAGE_SYSTEM_PROPERTIES]: 'Manage System Properties',
    [TEMPORARY_RESTRICTION_CHINA]: 'Temporary Restrictions for China',
    [SSO_ACCOUNT_STATISTICS]: 'SSO Self-Service Dashboard',

    [ANALYST_COMMENTARY_DEALS]: 'Analyst Commentary on Deals',
    [CREATE_MARKET_MAP_VERTICALS]: 'Create PitchBook Market Maps and Verticals',
    [PUBLISH_WORKSPACES]: 'Publish Workspaces',
    [MANAGE_SYSTEM_ACCOUNTS]: 'Manage System Accounts',
    [MANAGE_ENTITLEMENTS]: 'Manage Entitlements',
    [DELETE_ENTITLEMENTS]: 'Delete Entitlements',
    [MANAGE_ENTITLEMENT_PRESET]: 'Manage Entitlement Presets',
    [DELETE_ENTITLEMENT_PRESET]: 'Delete Entitlement Presets',

    [CONFERENCE_SETUP]: 'Create Conference',
    [CONFERENCE_EDIT]: 'Edit Conference',
    [CONFERENCE_VIEW]: 'View Conference',
};

export type AccessRight = keyof typeof ACCESS_RIGHTS;
